module.exports = __webpack_public_path__ + "static/img/la-petite-roche-novalloy-signs10.a7a7c70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/la-petite-roche/la-petite-roche-novalloy-signs10.jpg
// module id = 937
// module chunks = 0